import { PieSegment } from 'store/StatisticsPageStore'
import {
  PaginationProps,
  SortDirection
} from 'utilities'
import { StatsTableEntityObject } from '../StatsBaseTableStore'

/* export enum DraggableColLabels {
  STORE = 'Store',
  PROJECT = 'Project',
  PRODUCTS = 'Products'
} */

export enum StatsOverviewTableSortProps {
  BLOBS = 'blobs',
  PRODUCT_PAGES = 'productPages',
  POSTERS = 'posters',
  ADDED_TO_CART = 'addedToCart',
  PURCHASES = 'purchases',
  VOV = 'vov',
  TOTAL = 'total'
}

/*
export type StatsOverviewTableSearchProps = {
  projectIds: number[]
  productIds: number[]
} */

/*
export enum StatsOverviewTableColType {
  MAIN = 'main',
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export type StatsOverviewTableSettings = {
  draggableColumnsCount: number
  mainEntityColLabel: DraggableColLabels
  primaryCorrespondingEntityColLabel: DraggableColLabels
  secondaryCorrespondingEntityColLabel?: DraggableColLabels

}
*/
/* export type StatsOverviewTableEntityObject = ProjectDTO | ProductDTO | BrandDTO */

export type StatsOverviewTableEntity = {
  mainEntity: StatsTableEntityObject
  primaryCorrespondingEntities: StatsTableEntityObject[]
  primaryCorrespondingEntitiesCount: number
  secondaryCorrespondingEntities?: StatsTableEntityObject[]
  secondaryCorrespondingEntitiesCount?: number
  stats: {
    blobs: number
    blobAttached: number
    blobDetached: number
    blobsTotal: number
    product: number
    productAdded: number
    productTotal?: number
    posters: number
    posterAttached: number
    totalPosterAttachedTime?: number
    posterTotal?: number
    addedToCart?: number
    purchases: number
    vov: number
    total: number
  }
  bestItemPrimary?: PieSegment['bestItem']
  bestItemSecondary?: PieSegment['bestItem']
  children?: StatsOverviewTableEntity[]
}

export const statsOverviewTableInitialPaginationProps: PaginationProps<
  StatsOverviewTableSortProps
> = {
  page: 0,
  size: 6,
  sortDirection: SortDirection.ASC,
  sortProp: StatsOverviewTableSortProps.BLOBS,
  totalElements: 0,
  totalPages: 0
}

/* export const statsOverviewTableInitialSearchProps: StatsOverviewTableSearchProps = {
  projectIds: [],
  productIds: []
} */

/* export type SelectedCorrespondingEntitySets = {
  [DraggableColLabels.PROJECT]: Set<number>
  [DraggableColLabels.STORE]: Set<number>
  [DraggableColLabels.PRODUCTS]: Set<number>
}

export type SelectedCorrespondingEntitiesMap = Map<
  number,
  SelectedCorrespondingEntitySets
> */

// type PrimaryColFilter = `${number}-${number}`
// type SecondaryColFilter = `${number}-${number}-${number}`
/* export interface ColumnFilterSelections {
  main: Set<number>
  mainFull: Set<number>
  primary: Set<string>
  primaryFull: Set<string>
  secondary: Set<string>
  secondaryFull: Set<string>
}

export interface FilterOptionSettings {
  showImageForMain?: boolean
  showImageForPrimary?: boolean
  showImageForSecondary?: boolean
  skipPrimaryEntityGrouping?: boolean
} */
